export default __webpack_public_path__ + "static/media/landingpage.453d04ca.png";